import * as React from 'react';
import { Redirect, useRouteMatch } from 'react-router-dom';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { SettingsHome } from '../../components/SettingsHome';
import { SettingsCardType } from '../../models/setting';
import { ReportingContainer } from '../Reporting';
import { AgentTemplates } from './AgentTemplates';
import { Blitzes } from './Blitzes';
import { CallAnalysis } from './CallAnalysis';
import { Categories } from './Categories';
import { Gamification } from './Gamification';
import { Goals } from './Goals';
import { IssuesLog } from './IssuesLog';
import { PhoneNumbers } from './PhoneNumbers';
import { PrizesLog } from './PrizesLog';
import { ScenarioManagement } from './ScenarioManagement';
import { SlotMachinePrizes } from './SlotMachinePrizes';
import { SlotMachines } from './SlotMachines';
import { StartABlitz } from './StartABlitz';
import { Utilities } from './Utilities';

interface IRouteMatch {
	setting:
		| SettingsCardType.AgentTemplates
		| SettingsCardType.Blitzes
		| SettingsCardType.CallAnalysis
		| SettingsCardType.Categories
		| SettingsCardType.DashAndReports
		| SettingsCardType.Gamification
		| SettingsCardType.Goals
		| SettingsCardType.IssuesLog
		| SettingsCardType.PhoneNumbers
		| SettingsCardType.PrizesLog
		| SettingsCardType.ScenarioManagement
		| SettingsCardType.SlotMachinePrizes
		| SettingsCardType.SlotMachines
		| SettingsCardType.StartABlitz
		| SettingsCardType.Utilities;
}

export const SettingsContainer = () => {
	const match = useRouteMatch<IRouteMatch>('/settings/:setting');
	const userSession = useUserSession();

	switch (match?.params?.setting) {
		case SettingsCardType.AgentTemplates:
			return userSession.account.isAdmin && userSession.account.isLevitateSalesCoffeeAccount ? (
				<AgentTemplates />
			) : (
				<Redirect to='/queue' />
			);
		case SettingsCardType.Blitzes:
			return <Blitzes />;
		case SettingsCardType.CallAnalysis:
			return <CallAnalysis />;
		case SettingsCardType.Categories:
			return <Categories />;
		case SettingsCardType.DashAndReports:
			return <ReportingContainer />;
		case SettingsCardType.Gamification:
			return <Gamification />;
		case SettingsCardType.Goals:
			return <Goals />;
		case SettingsCardType.IssuesLog:
			return userSession.account.isAdmin ? <IssuesLog /> : <Redirect to='/queue' />;
		case SettingsCardType.ScenarioManagement:
			return userSession.account.isAdmin && userSession.account.isLevitateSalesCoffeeAccount ? (
				<ScenarioManagement />
			) : (
				<Redirect to='/queue' />
			);
		case SettingsCardType.PhoneNumbers:
			return <PhoneNumbers />;
		case SettingsCardType.PrizesLog:
			return userSession.account.features.aida.achievementsEnabled ? <PrizesLog /> : <Redirect to='/queue' />;
		case SettingsCardType.SlotMachinePrizes:
			return userSession.account.features.aida.achievementsEnabled ? <SlotMachinePrizes /> : <Redirect to='/queue' />;
		case SettingsCardType.SlotMachines:
			return userSession.account.features.aida.achievementsEnabled ? <SlotMachines /> : <Redirect to='/queue' />;
		case SettingsCardType.StartABlitz:
			return <StartABlitz />;
		case SettingsCardType.Utilities:
			return <Utilities />;
		default:
			return <SettingsHome />;
	}
};
